import { useTranslation } from "@opendash/core";
import { Card, Statistic } from "antd";
import { observer } from "mobx-react-lite";
import Parse from "parse";
import * as React from "react";
import { useEffect, useState } from "react";
import {
  Kanban_State,
  Ticket_Kanban_State,
  Ticket_Kanban_State_Current,
} from "../../../js/parsegenerated";
import { KanbanStateSelect } from "../../tickets";
import { useDurationFormat } from "../hooks/useDurationFormat";
/**
 * The mean time to repair (MTTR) is the average time taken to repair a failed component or device.
 */
export default observer(function MeantTimeToRepair(props: {
  ticketEndStates: Ticket_Kanban_State_Current[];
}) {
  const t = useTranslation();
  const [mttr, setMttr] = useState(0);
  const [stateId, setStateId] = useState<string | number>(undefined);
  const formatMTTR = useDurationFormat(mttr);

  useEffect(() => {
    async function calculate() {
      if (!stateId) return;

      let sum = 0;
      let count = 0;

      for (const ticketEndState of props.ticketEndStates) {
        const ticketStateQuery = new Parse.Query(Ticket_Kanban_State)
          .ascending("createdAt")
          .equalTo("ticket", ticketEndState.get("ticket"))
          .equalTo(
            "state",
            new Kanban_State({ objectId: stateId?.toString() })
          );

        const ticketState = await ticketStateQuery.first();

        if (!ticketState) continue;

        const end = ticketEndState.get("updatedAt")?.getTime() ?? 0;
        const begin = ticketState.get("createdAt")?.getTime() ?? 0;

        if (!begin || !end) continue;

        sum += end - begin;
        count++;
      }

      setMttr(sum > 0 && count > 0 ? sum / count : 0);
    }

    calculate();
  }, [props.ticketEndStates, stateId]);

  return (
    <>
      {/* 
// @ts-ignore */}
      <Card variant="outlined">
        <Statistic
          title={
            <>
              {t("maintenance:stats.mean_time_to_repair.statistic.title")}
              <KanbanStateSelect
                value={stateId}
                onChange={setStateId}
                placeholder={t(
                  "maintenance:stats.mean_time_to_repair.state.select"
                )}
              />
            </>
          }
          value={formatMTTR}
        />
      </Card>
    </>
  );
});
